import React from 'react';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline' | 'error' | 'ghost';
  size?: 'sm' | 'md' | 'lg';
}

export const Button: React.FC<ButtonProps> = ({ 
  children, 
  variant = 'primary', 
  size = 'md', 
  className = '', 
  ...props 
}) => {
  const baseStyles = 'font-button transition-all active:scale-95 disabled:opacity-50 disabled:pointer-events-none rounded-[16px] flex items-center justify-center gap-2';
  
  const variants = {
    // Mint Green solid
    primary: 'bg-primary-container text-on-primary-container hover:brightness-105 shadow-sm',
    // Pure Black solid (grounded authority)
    secondary: 'bg-on-background text-white hover:opacity-90',
    // Outlined Black (1px) as per DESIGN.md
    outline: 'border border-on-background text-on-background hover:bg-surface-container-high',
    // Error
    error: 'bg-error text-white hover:brightness-110',
    // Ghost
    ghost: 'bg-transparent text-secondary hover:bg-surface-container-low hover:text-primary'
  };
  
  const sizes = {
    sm: 'px-4 py-2 text-xs',
    md: 'px-6 py-3 text-sm',
    lg: 'px-8 py-4 text-base'
  };

  return (
    <button 
      className={`${baseStyles} ${variants[variant]} ${sizes[size]} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};
